import { render } from "./PortafolioProjects.vue?vue&type=template&id=4b7a55c8"
import script from "./PortafolioProjects.vue?vue&type=script&lang=js"
export * from "./PortafolioProjects.vue?vue&type=script&lang=js"

import "./PortafolioProjects.vue?vue&type=style&index=0&id=4b7a55c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__